import React, { useState, ReactNode, useEffect, ErrorInfo } from 'react'
import { useRollbar } from '@rollbar/react'

interface NoRollbarErrorBoundaryProps {
  children: ReactNode
  onError?: (error: Error | null, errorInfo: ErrorInfo | null) => void
  fallbackUI?: ReactNode
}

export const NoRollbarErrorBoundary = ({
  children,
  onError,
  fallbackUI,
}: NoRollbarErrorBoundaryProps) => {
  const [hasError, setHasError] = useState(false)
  // biome-ignore lint/correctness/noUnusedVariables: <explanation>
  const [error, setError] = useState<Error | null>(null)
  // biome-ignore lint/correctness/noUnusedVariables: <explanation>
  const [errorInfo, setErrorInfo] = useState<ErrorInfo | null>(null)
  const rollbar = useRollbar()

  const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
    setHasError(true)
    setError(error)
    setErrorInfo(errorInfo)
    if (onError) {
      onError(error, errorInfo)
    }

    if (rollbar) {
      if (error.message.includes('critical')) {
        rollbar.error(error)
      } else {
        // biome-ignore lint/suspicious/noConsole: <explanation>
        console.log('No rollbar error: ', error)
      }
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    window.onerror = (message, source, lineno, colno, error) => {
      if (error) {
        handleError(error, {
          componentStack: `Error: ${message} in ${source}:${lineno}:${colno}`,
        })
      }
      return true // предотвращаем стандартное поведение
    }
  }, [rollbar])

  if (hasError && fallbackUI) {
    return <>{fallbackUI}</>
  }

  return <>{children}</>
}
